<template>
  <v-card
    class="d-flex flex-column"
    border
    flat
    tile
  >
    <v-card-title
      class="text-wrap"
      data-cy="grant-card-name"
    >
      {{ $bct(grantProgram.name) }}
    </v-card-title>

    <v-card-text>
      <div
        class="d-flex align-center mb-2"
        data-cy="grant-opens"
      >
        <v-icon
          class="me-3"
          color="primary"
          icon="brightness_1"
        />
        <div class="d-inline-block">
          {{ $bct('Open') }}
        </div>
        <div class="d-inline-block">
          <span class="me-1">:</span>
          <LongDate :date="grantProgram.opens_at" />
        </div>
      </div>

      <div
        class="d-flex align-center mb-4"
        data-cy="grant-closes"
      >
        <v-icon
          class="me-3"
          color="primary"
          icon="radio_button_unchecked"
        />
        <div class="d-inline-block">
          {{ $bct('Closed') }}
        </div>
        <div class="d-inline-block">
          <span class="me-1">:</span>
          <LongDate
            :date="grantProgram.closes_at"
            nulltext="TBD"
          />
        </div>
      </div>
    </v-card-text>

    <v-divider />

    <v-row class="py-3 flex-0-0">
      <v-col class="d-flex justify-center align-center px-6">
        <v-btn
          :to="{
            name: 'GrantProgramShow',
            params: { grantProgramId: grantProgram.id },
          }"
          :variant="grants.length > 0 ? 'outlined' : undefined"
          append-icon="east"
          class="focus-very-visible td-none"
          color="primary"
          data-cy="grant-program-link"
          size="x-large"
          block
        >
          {{
            grants.length > 0 ? $bct('Submit and view applications') : $bct('Learn more and apply')
          }}
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script setup>
import LongDate from '@/shared/components/LongDate.vue';

const $bct = inject('translator');

defineProps({
  grants: {
    type: Array,
    default: null,
  },
  grantProgram: {
    type: Object,
    default: null,
  },
});
</script>
